<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-user__user">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.memberCode" placeholder="请输入ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.memberName" placeholder="账号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.memberNichen" placeholder="昵称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.memberVip" placeholder="是否vip" clearable filterable >
            <el-option
                v-for="item in isVipArray"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.vipPeriod" placeholder="vip类型" clearable filterable >
            <el-option
                v-for="item in vipTypeArray"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="memberCode" label="id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="memberNichen" label="用户昵称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="memberAvatar" label="用户头像" header-align="center" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.memberAvatar" width="40" height="40" alt=""/>
          </template>
        </el-table-column>
        <el-table-column prop="memberName" label="账号" header-align="center" align="center"></el-table-column>

        <el-table-column prop="memberCion" label="金币数量" header-align="center" align="center"></el-table-column>
        <el-table-column prop="balance" label="提现余额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="memberVip" label="是否vip" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.memberVip === 0">否</el-tag>
            <el-tag v-else  size="success" type="success">是</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="vipPeriod" label="vip类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.vipPeriod === 0">否</el-tag>
            <el-tag v-if="scope.row.vipPeriod === 1" size="success" type="success">月卡</el-tag>
            <el-tag v-if="scope.row.vipPeriod === 2" size="success" type="success">季卡</el-tag>
            <el-tag v-if="scope.row.vipPeriod === 3" size="success" type="success">年卡</el-tag>
            <el-tag v-if="scope.row.vipPeriod === 4" size="success" type="success">永久卡</el-tag>
            <el-tag v-if="scope.row.vipPeriod === 5" size="success" type="success">试用VIP</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="vipDate" label="VIP到期时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pid" label="上級ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="wxOpenid" label="微信openid" header-align="center" align="center"></el-table-column>
        <el-table-column prop="wxUnionid" label="微信Unionid" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>

        <el-table-column prop="ip" label="ip" show-overflow-tooltip header-align="center" align="center"></el-table-column>
        <el-table-column prop="address" label="地址" width="100" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userAgent" label="浏览器" show-overflow-tooltip header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('user:user:update')" type="text" size="small" @click="addOrUpdateHandleUser(scope.row.memberCode)">{{ $t('update') }}</el-button>
            <el-button  type="text" size="small" @click="vipUpdateHandleUser(scope.row.memberCode)">vip管理</el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
      <vip-update v-if="vipUpdateVisible" ref="vipUpdate" @refreshDataList="refreshDataList"></vip-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import dateTimeRangeMixin from '@/mixins/datetime-range'
import AddOrUpdate from './user-add-or-update'
import vipUpdate from './user-vip-update'
export default {
  mixins: [mixinViewModule, dateTimeRangeMixin],
  data () {
    return {
      isVipArray:[
        {
          value: '0',
          label: '否'
        },{
          value: '1',
          label: '是'
        },
      ],
      vipTypeArray:[
        {
          value: '0',
          label: '否'
        },{
          value: '1',
          label: '月卡'
        },{
          value: '2',
          label: '季卡'
        },{
          value: '3',
          label: '年卡'
        },{
          value: '4',
          label: '永久卡'
        }
      ],
      mixinViewModuleOptions: {
        getDataListURL: '/user/user/page',
        getDataListIsPage: true,
        exportURL: '/user/user/export',
        deleteURL: '/user/user',
        deleteIsBatch: true
      },
      dateRange: null,
      vipUpdateVisible: false,
      dataForm: {
        memberCode: '',
        memberVip: '',
        vipPeriod: ''

      }
    }
  },
  components: {
    AddOrUpdate,
    vipUpdate
  },

  watch: {
    'dateRange'(val) {
      if (!val || val.length === 0) {
        this.dataForm.startDate = null
        this.dataForm.endDate = null
      } else {
        // datetimerange 已经包含完整的日期时间,直接赋值
        this.dataForm.startDate = val[0]
        this.dataForm.endDate = val[1]
      }
    }
  },
  methods: {
    addOrUpdateHandleUser (id) {
      console.log(id,"id1")
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.dataForm.memberCode = id || ''
        this.$refs.addOrUpdate.init()
      })
    },
    vipUpdateHandleUser (id) {
      console.log(id,"id2")
      this.vipUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.vipUpdate.init(id)
      })

    }
  }
}
</script>
